import '../../../../../../../Avency.Avency.Shared/Resources/Private/Assets/JavaScript/Project/globals';
import ReferenceList from './ReferenceList';
import PageLoadedQueue from '../../../../../../../Avency.Avency.Shared/Resources/Private/Assets/JavaScript/Project/PageLoadedQueue';

(function(window) {
    PageLoadedQueue.addFunction(function () {
        const referenceLists = document.querySelectorAll('.reference-list');
        window.ReferenceLists = [];

        if (referenceLists.length > 0) {
            Array.from(referenceLists).forEach(referenceList => {
                window.ReferenceLists.push(new ReferenceList(referenceList));
            });
        }
    });
})(window);
